<template>
  <article
    class="flex flex-[1_53%_1_1] w-full gap-12 flex-row items-center p-4 shadow-md rounded border-l-4 border-h-primary-500"
  >
    <img
      :src="course.file?.url"
      :alt="course.name"
      class="w-[123px] min-w-[123px] h-[73px] object-cover rounded"
     @emptied="'@/assets/images/image-default.svg'"
    />
    <p class="flex-[53%] text-h-neutral-900">{{ course.name }}</p>
    <p
      class="rounded-2xl text-center py-[2.5px] w-[78px] px-2 text-xs"
      :class="[
        { 'text-white bg-h-primary-500': !course.adaptive },
        { ' text-h-neutral-50 bg-h-secondary-600': course.adaptive },
      ]"
    >
      {{ labelCourseType }}
    </p>
    <Button
      class="btn-simple gap-2 flex-1 min-w-[183px]"
      @click="redirectToForum"
    >
      <span>
        {{ $t("labels.generic", { pt: "Acessar fórum", en: "Access forum" }) }}
      </span>
      <v-icon name="co-arrow-right" width="24" height="24" />
    </Button>
  </article>
</template>
<script lang="ts">
import { Course } from "@/models/courses.model";
import { useCourseStudentStore } from "@/store/course-student";
import { GoToRoute } from "@/utils/go-to.util";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "card-forum",
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true,
    },
  },
  methods: {
    redirectToForum(): void {
      const courseName = this.course.name.toLowerCase().replaceAll(" ", "-");
      localStorage.setItem("course-type", JSON.stringify(this.course?.type));
      useCourseStudentStore.setCourseType(this.course?.type!);

      this.go.redirectToPage("forum", {
        courseName: courseName,
        id: this.course.id,
      });

    },
  },
  computed: {
    labelCourseType(): string {
      return this.course.adaptive
        ? this.$t("labels.generic", { pt: "Adaptativo", en: "Adaptative" })
        : this.$t("labels.generic", { pt: "Tradicional", en: "Traditional" });
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
});
</script>
